<template>
  <div>
    <modal
      :show="!!currentModal"
      type="dark"
      :prev-btn="showPrevButton"
      :close-btn="showCloseButton"
      :custom-btn="useCustomButton"
      :preview-btn="[modalTypes.update].includes(currentModal)"
      :close-btn-size="closeBtnSize"
      :closeable="true"
      @prev="prevHanlder"
      @closed="closeHandler"
    >
      <template #customBtn>
        <span v-if="currentModal === modalTypes.login">
          <a
            class="register"
            @click="showVisitorWelcomePopup"
          >
            {{ $t('general.register') }}
          </a>
        </span>
      </template>
      <signup
        v-if="[modalTypes.signup, modalTypes.update].includes(currentModal)"
        :type="currentModal"
        :form-data="currentModal === modalTypes.signup ? ticketInfo : userFormData"
        @to-login="setCurrentModal(modalTypes.login)"
        @to-change-password="setCurrentModal(modalTypes.password)"
        @update="setCurrentModal('');"
        @signup="setCurrentModal(''); record($event); enter($event);"
      />
      <password
        v-if="currentModal === modalTypes.password"
        :username="authUser.email"
        @to-update="setCurrentModal(modalTypes.update)"
      />
      <login
        v-if="currentModal === modalTypes.login"
        @login="setCurrentModal('')"
      />
    </modal>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import Modal from './Modal'
import Signup from './Edit'
import Login from './Login'
import Password from './Edit/Password'

export const MODALS = {
  signup: 'create',
  update: 'update',
  login: 'login',
  password: 'password'
}
export const ROLES = ['EXHIBITOR', 'VISITOR']
export default {
  name: 'VrLounge',
  components: {
    Signup,
    Modal,
    Login,
    Password
  },
  data () {
    return {
      modalTypes: MODALS,
      ticketInfo: {},
      ticketNumber: '',
      updateTimer: -1
    }
  },
  computed: {
    ...mapGetters({
      currentModal: 'vrlounge/currentModal',
      authUser: 'auth/user',
      isFavoritesEnabled: 'favorites/enabled'
    }),
    ...mapGetters([
      'currentBuilding'
    ]),
    userFormData () {
      return {
        ...this.authUser
      }
    },
    useCustomButton () {
      return this.currentModal === this.modalTypes.login
    },
    closeBtnSize () {
      if (this.currentModal === this.modalTypes.login) {
        return '32px'
      }
      return undefined
    }
  },
  watch: {
    'authUser.objectId' (val) {
      if (!val) {
        // logout
        location.reload()
      }
    }
  },
  beforeDestroy () {
    clearInterval(this.updateTimer)
  },
  methods: {
    ...mapActions({
      setCurrentModal: 'vrlounge/setCurrentModal',
      initFavorite: 'favorites/init'
    }),
    ...mapActions([
      'showVisitor',
      'closeVisitor'
    ]),
    async enter () {
      if (this.isFavoritesEnabled) {
        this.initFavorite()
      }
    },
    prevHanlder () {
      if (this.currentModal === this.modalTypes.password) {
        this.setCurrentModal('update')
      } else {
        this.setCurrentModal('')
      }
    },
    closeHandler () {
      if (!this.currentBuilding) return
      const { requireVisitorData, requireWhiteListing } = this.currentBuilding
      const notRequireVisitorValidation = !requireVisitorData && !requireWhiteListing
      if (this.currentModal === this.modalTypes.login && notRequireVisitorValidation) {
        this.closeVisitor()
      }
      this.setCurrentModal('')
    },
    checkWhiteListVerify (whiteList = [], username = '') {
      return !!whiteList.includes(username)
    },
    showVisitorWelcomePopup () {
      this.setCurrentModal('')
      this.showVisitor()
    }
  }
}
</script>

<style lang="stylus" scoped>
.register {
  font-size: 16px
  color: rgba(#FFF, .74)
  text-decoration: underline
}
</style>
